module.exports = __webpack_public_path__ + "img/left-leg_active.6ea19175.png";